export default {
    contato: undefined,
    search: '',
    conversa: [],

    contatos: [],
    selecionados: []
}